const salesforceCompany = {
    pageView: [
        '.windowViewMode-normal.oneContent.active.lafPageHost',
        '.slds-page-header__row',
        '.oneRecordHomeFlexipage2Wrapper',
    ],
    forceHighlightsPanel_QuerySelector: '.slds-page-header__title',
};
export const SALESFORCE_LIGHTNING_INDICATORS_BY_CONTEXT_TYPE = {
    profile: {
        pageView: [
            '.windowViewMode-normal.oneContent.active.lafPageHost',
            '.slds-page-header__row',
            '.oneRecordHomeFlexipage2Wrapper',
        ],
        forceHighlightsPanel_QuerySelector: '.slds-page-header__title .uiOutputText, .slds-page-header__title lightning-formatted-name',
    },
    company: salesforceCompany,
    unknown: salesforceCompany,
};
